import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../api";
import API_URL from "../config";
import {
    Box,
    Button,
    TextField,
    Typography,
    Container,
    Paper,
} from "@mui/material";

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    // Check if the user is already authenticated
    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${API_URL}/verify-token`, {
                    method: "GET",
                    credentials: "include", // Include cookies in the request
                });

                if (response.ok) {
                    navigate("/admin/dashboard", { replace: true }); // Redirect to dashboard if authenticated
                }
            } catch (err) {
                // Do nothing if the user is not authenticated
            }
        };

        checkAuth();
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await login(username, password);
            navigate("/admin/dashboard", { replace: true }); // Redirect to dashboard after login
        } catch (err) {
            alert("Login failed");
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} sx={{ padding: 4, marginTop: 8 }}>
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Admin Login
                </Typography>
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >
                    <TextField
                        label="Username"
                        variant="outlined"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        fullWidth
                        required
                    />
                    <TextField
                        label="Password"
                        type="password"
                        variant="outlined"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        fullWidth
                        required
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth
                    >
                        Login
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}

export default Login;
